<template>
  <div class="w-full">
    <div class="w-full" v-if="isLoading">
      <vx-card class="w-full">
        <div class="dashboard-task-list w-full" v-for="index in count" :key="index">
          <div class="task-container vx-row">
            <div class="vx-col  xs:w-full sm:w-full md:w-full lg:w-2/3 xl:w-1/2 w-full  task-name mr-3">
              <custom-skeleton :fullWidth="true"  animation="wave" type="text" :count="1" height="50px" width="100%"></custom-skeleton>
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/4 w-full  task-stats mr-3 mb-2">
              <custom-skeleton  animation="wave" type="text" :count="1" height="50px" width="100%"></custom-skeleton>
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/6 w-full task-status mr-3">
              <custom-skeleton :fullWidth="true"  animation="wave" type="text" :count="1" height="50px" width="100%"></custom-skeleton>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="w-full" v-if="!isLoading" >
      <vx-card class="w-full">
        <div class="dashboard-task-list w-full" v-for="(task,taskIndex) in taskList" :key="taskIndex">
          <div class="task-container vx-row">
            <div class="vx-col  xs:w-full sm:w-full md:w-full lg:w-2/3 xl:w-1/2  task-name mr-3">
              <feather-icon class="mr-3"  :icon="icon(task.typeId)"></feather-icon>
              <p>{{`${taskIndex+1}) ${task.name}`}}</p>
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/3 xl:w-1/4 w-full  task-stats mr-3 mb-2">
              <double-slider :hideTimeSpent="true" :width="250" :avgTime="task.avgTime" :myTime="task.myTime" ></double-slider>
            </div>
            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/6 w-full task-status mr-3">
              <p :class="task.completed ? 'task-completed-color' : 'task-nyc-color'" >{{task.completed ? `Completed` : `Not yet started` }}</p>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import CustomSkeleton from './CustomSkeleton.vue'
import DoubleSlider from './DoubleSlider.vue'

export default {
  data(){
    return{
      
    }
  },
  components:{
    CustomSkeleton,
    DoubleSlider
  },
  props:{
    isLoading:{
      type:Boolean,
      required:true
    },
    count:{
      type:Number,
      required:true,
    },
    taskList:{
      type:Array,
      required:true,
    },
  },
  methods:{
    icon(typeId){
      switch (typeId) {
        case 2:
          return 'YoutubeIcon';
        case 9:
          return 'EditIcon';
        default:
          return 'FileTextIcon';
      }
    }
  },
  mounted(){
  },
  
}
</script>



<style scoped lang="scss">

.dashboard-task-list:not(:last-child){
  margin-bottom: 15px;
}
.task-container{
  background-color: rgba(var(--vs-background),100);
  padding: 5px;
  height:fit-content;
  border-radius: 0.5rem;
}

.wrapper {
  display: grid;
  grid-template-columns: 30px 2fr 1fr 1fr;
}

.task-icon{
  justify-content: center;
  align-items: center;
  display: flex;
  height: 50px;
}

.task-name{
  height: 50px;
  display: flex;
  align-items: center;
  text-align: left;
  width: 600px;
}

.task-status{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.task-stats{
  height: 50px;
}

@media screen and(max-width:500px){
  .task-name{
    height: fit-content;
    word-break: break-word;
  }
  .task-status{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: fit-content;
    .progress-container{
      width: fit-content;
    }
  }
}

@media screen and(max-width:916px){
  .task-status{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
  }
}

.task-completed-color{
  color: var(--success);
  font-weight: bold;
}
.task-nyc-color{
  color: var(--warning);
  font-weight: bold;
}

</style>
